import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
var _excluded = ["fillColor", "strokeColor", "strokeWidth", "size"];
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { withSubcomponents } from '../utils.js';
var Path = function Path(_ref) {
  var args = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("path", _objectSpread({
      d: "M8.75038 6.15645L8.66249 11.9456C8.65659 12.3924 8.30016 12.7243 7.86725 12.6917C7.85435 12.6904 7.8445 12.6874 7.83348 12.6894L3.9158 12.2038L9.67913 18.6143C10.6769 17.0167 12.5164 15.4286 13.7068 14.7413C14.8973 14.054 17.1923 13.2549 19.0748 13.1897L16.4048 4.99327L14.8666 8.62889C14.6969 9.03114 14.2377 9.19196 13.8382 8.99222C13.8264 8.98595 13.8166 8.98294 13.8079 8.97492L8.75038 6.15645Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M9.20309 19.4975C8.93578 19.0345 8.95971 18.4642 9.26676 18.0609C10.4676 16.4634 12.2409 14.9787 13.4436 14.2844C14.6462 13.59 16.8186 12.7966 18.8025 12.5554C19.3053 12.4912 19.8112 12.7556 20.0785 13.2186C20.519 13.9815 20.141 14.9301 19.3266 15.0873C17.6015 15.4181 15.8593 16.0849 14.8302 16.6791C13.8011 17.2732 12.3526 18.4486 11.2035 19.7772C10.6589 20.4089 9.64546 20.2637 9.20309 19.4975Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M9.70727 7.81225C10.5615 7.31908 10.8258 6.17772 10.2977 5.26296C9.76952 4.3482 8.64891 4.00644 7.79471 4.49961C6.94051 4.99278 6.67619 6.13414 7.20432 7.0489C7.73246 7.96366 8.85307 8.30542 9.70727 7.81225Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M17.3625 6.64428C18.2167 6.15111 18.4811 5.00975 17.9529 4.09499C17.4248 3.18023 16.3042 2.83847 15.45 3.33164C14.5958 3.82481 14.3315 4.96617 14.8596 5.88093C15.3877 6.79569 16.5083 7.13745 17.3625 6.64428Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M4.86742 13.8591C5.72163 13.366 5.98595 12.2246 5.45781 11.3098C4.92968 10.3951 3.80907 10.0533 2.95487 10.5465C2.10067 11.0397 1.83634 12.181 2.36448 13.0958C2.89262 14.0105 4.01322 14.3523 4.86742 13.8591Z"
    }, args))]
  });
};
var ViewBox = "0 0 24 24";
var _Crown = forwardRef(function (_ref2, ref) {
  var _ref2$fillColor = _ref2.fillColor,
    fillColor = _ref2$fillColor === void 0 ? "#ffffff" : _ref2$fillColor,
    _ref2$strokeColor = _ref2.strokeColor,
    strokeColor = _ref2$strokeColor === void 0 ? "black" : _ref2$strokeColor,
    _ref2$strokeWidth = _ref2.strokeWidth,
    strokeWidth = _ref2$strokeWidth === void 0 ? 0 : _ref2$strokeWidth,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 24 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: ViewBox,
    fill: "none",
    paintOrder: "stroke"
  }, rest), {}, {
    children: [/* @__PURE__ */jsx("defs", {
      children: /* @__PURE__ */jsx("clipPath", {
        id: "crown_clip_path",
        children: /* @__PURE__ */jsx("rect", {
          width: "18",
          height: "15",
          fill: "white",
          transform: "translate(0 9) rotate(-30)"
        })
      })
    }), /* @__PURE__ */jsx("g", {
      clipPath: "url(#crown_clip_path)",
      children: /* @__PURE__ */jsx(Path, {
        fill: fillColor,
        stroke: strokeColor,
        strokeWidth: strokeWidth
      })
    })]
  }));
});
_Crown.displayName = "Crown";
var Crown = withSubcomponents(_Crown, {
  Path: Path,
  ViewBox: ViewBox
});
export { Crown };